export const USCADA_CONTACT_EMAIL = 'uscadapro@gmail.com';
